/**
 * @author lifei
 */
import { aCustomer, aOrder } from '@/apis'
import * as ENUM from '@/enum'
import { type SelectProps } from 'ant-design-vue'
const { SalesCenter } = ENUM
import XHChooseCategory from '../../../chooseCategory/index.vue'

const bigDirectoryId = ref({ bigDirectoryId: '' })
export const formConfig: TCommon.TFormCtrl.Config = {
  name: 'formCommodity',
  column: 4, // 列数
  row: 2, // 默认行数
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  children: [
    {
      label: '目录期号',
      name: 'bigIssueNo',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      // required: true,
      aProps: <SelectProps>{
        fieldNames: {
          label: 'directoryCode',
          value: 'directoryCode',
        },
        isPaging: false,
        disabled: false,
      },
      options: {
        statusList: [4, 5, 10],
      },
      dataSource: () => aOrder.directory.getDirectoryDropDown,
    },
    // 暂时隐藏
    {
      label: '小目录期号',
      name: 'smallDirectoryId',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'name',
          value: 'id',
        },
        isPaging: false,
      },
      options: bigDirectoryId.value,
      dataSource: () => aOrder.smallDirectory.smallDirectory,
      showIf: (directoryType: string) => directoryType == '2',
    },
    {
      label: '开始序号',
      name: 'startNum',
      placeholder: '请输入',
      component: 'XHInput',
      dataSource: () => '',
    },
    {
      label: '结束序号',
      name: 'endNum',
      placeholder: '请输入',
      component: 'XHInput',
      dataSource: () => '',
    },
    {
      label: '书名',
      name: 'name',
      placeholder: '请输入',
      component: 'XHInput',
      dataSource: () => '',
    },
    {
      label: '书号',
      name: 'isbn',
      placeholder: '请输入',
      component: 'XHInput',
      dataSource: () => '',
    },
    {
      label: '类目',
      name: 'categoryId',
      placeholder: '请选择',
      component: XHChooseCategory,
    },
    {
      label: 'SPUID',
      name: 'spuId',
      placeholder: '请输入',
      component: 'XHInput',
      dataSource: () => '',
    },
    {
      label: 'SKUID',
      name: 'skuId',
      placeholder: '请输入',
      component: 'XHInput',
      dataSource: () => '',
    },
    {
      label: '版别',
      name: 'version',
      placeholder: '请输入',
      component: 'XHInput',
      dataSource: () => '',
    },
    {
      label: '教材分类',
      name: 'textbookId',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'categoryName',
          code: 'categoryCode',
          value: 'id',
        },
        mode: 'multiple',
        showKey: 'categoryCode',
      },
      options: {
        type: 1,
      },
      dataSource: () => aOrder.categoryConfig.page,
    },
    {
      label: '当地教材分类',
      name: 'localBookCategoryId',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'categoryName',
          value: 'id',
        },
        mode: 'multiple',
        showKey: 'categoryCode',
      },
      options: {
        type: 1,
      },
      dataSource: () => aOrder.categoryConfig.page,
    },
    {
      label: '使用年级',
      name: 'gradeIds',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'name',
          value: 'id',
        },
        showKey: 'code',
        isPaging: false,
        mode: 'multiple',
      },
      options: {
        type: 1,
      },
      dataSource: () => aOrder.grade.gradeDropDown,
    },
    {
      label: '循环教材',
      name: 'ifLoopTextbook',
      placeholder: '请选择',
      component: 'XHSelectSync',

      dataSource: () => SalesCenter.EnIfLoopTextbookStatus,
    },
    {
      label: '循环比例',
      name: 'loopRate',
      placeholder: '请选择',
      component: 'XHSelectSync',
      aProps: <SelectProps>{
        mode: 'multiple',
      },
      dataSource: () => SalesCenter.EnLoopRateStatus,
    },
    {
      label: '年级分类',
      name: 'gradeClassifyId',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'categoryName',
          value: 'id',
        },
        mode: 'multiple',
        showKey: 'categoryCode',
      },
      options: {
        type: 5,
      },
      dataSource: () => aOrder.categoryConfig.page,
    },
    {
      label: '教辅分类',
      name: 'bookClassifyId',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'categoryName',
          value: 'id',
        },
        mode: 'multiple',
        showKey: 'categoryCode',
      },
      options: {
        type: 0,
      },
      dataSource: () => aOrder.categoryConfig.page,
    },
    {
      label: '学科分类',
      name: 'subjectId',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'categoryName',
          value: 'id',
        },
        mode: 'multiple',
        showKey: 'categoryCode',
      },
      options: {
        type: 4,
      },
      dataSource: () => aOrder.categoryConfig.page,
    },

    {
      label: '适用版本',
      name: 'fitVersionCode',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'categoryName',
          value: 'categoryCode',
        },
        mode: 'multiple',
        showKey: 'categoryCode',
      },
      options: {
        type: 3,
      },
      dataSource: () => aOrder.categoryConfig.page,
    },
    {
      label: '是否免费',
      name: 'ifFree',
      placeholder: '请选择',
      component: 'XHSelectSync',

      dataSource: () => SalesCenter.isFreeStatus,
    },
    {
      label: '供应商',
      name: 'supplierCode',
      placeholder: '请选择',
      component: 'XHSelectAsync',
      aProps: <SelectProps>{
        fieldNames: {
          label: 'name',
          value: 'code',
        },
        searchName: '',
        mode: 'multiple',
        showKey: 'code',
      },

      dataSource: () => aCustomer.supplier.allSuppliers,
    },
    {
      label: '是否组合品种',
      name: 'ifAssembly',
      placeholder: '请选择',
      component: 'XHSelectSync',
      dataSource: () => SalesCenter.ifAssemblyStatus,
    },
  ],
}
